import { ComponentInstall } from "../../utils";
import InputField from "./src";

export default ComponentInstall(InputField);
